// extracted by mini-css-extract-plugin
module.exports = {"promoBanner":"PromoBannerPDP_promoBanner__zegPl","promoLink":"PromoBannerPDP_promoLink__rldEl"};